module.exports = __webpack_public_path__ + "static/media/theme2.3969da49.png";